import React from "react";
import {
  Box,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Button
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation } from "react-router-dom";

const AllResponsesPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get responses and property details from navigation state
  const { responses = [], propertyDetails = {} } = location.state || {};

  const colors = {
    primary: "#1a1a1a", 
    secondary: "#8B7355", 
    accent: "#A52A2A", 
    background: "#b9a990", 
    cardBackground: "#FFFFFF", 
    textDark: "#1a1a1a", 
    textLight: "#FFFFFF", 
    textMuted: "#666666"
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', { 
      day: 'numeric', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  const renderResponseItem = (response, index) => (
    <Box key={index} sx={{ mb: 2, p: 2, backgroundColor: 'white', borderRadius: 1, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e0e0e0' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Avatar sx={{ width: 32, height: 32, mr: 1, bgcolor: colors.secondary, color: colors.textLight, fontSize: '0.8rem' }}>
          U
        </Avatar>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Typography variant="body1" fontWeight="bold" color={colors.primary} sx={{ fontSize: '0.9rem' }}>
            User {response.user_id}
          </Typography>
          <Typography variant="body2" color={colors.textMuted} sx={{ fontSize: '0.8rem' }}>
            {formatDate(response.created_at || new Date())}
          </Typography>
        </Box>
      </Box>
      
      {response.comment && (
        <Typography variant="body2" sx={{ color: colors.textDark, lineHeight: 1.4, mb: 1, fontSize: '0.85rem' }}>
          {response.comment}
        </Typography>
      )}
      
      {response.proerty_link && (
        <Box sx={{ mt: 1 }}>
          <Button 
            component="a" 
            href={response.proerty_link} 
            target="_blank" 
            rel="noopener noreferrer"
            variant="outlined"
            size="small"
            sx={{ 
              color: '#1976d2', 
              borderColor: '#1976d2',
              fontSize: '0.8rem',
              textTransform: 'none',
              '&:hover': { 
                backgroundColor: '#1976d2',
                color: 'white',
                borderColor: '#1976d2'
              } 
            }}
          >
            🔗 View Property
          </Button>
        </Box>
      )}
    </Box>
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "#d8ccba" }}>
      <AppBar position="static" sx={{ backgroundColor: colors.primary, color: colors.textLight }}>
        <Toolbar>
          <IconButton onClick={() => navigate(-1)} sx={{ color: colors.textLight }}>
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2, flex: 1 }}>
            All Responses ({responses.length})
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Property Summary */}
      {/* {propertyDetails && (
        <Box sx={{ p: 2, backgroundColor: colors.cardBackground, borderBottom: `1px solid #e0e0e0` }}>
          <Typography variant="h6" sx={{ mb: 1, color: colors.primary, fontSize: '1rem' }}>
            {propertyDetails.looking_for ? propertyDetails.looking_for.charAt(0).toUpperCase() + propertyDetails.looking_for.slice(1) : "Property"} Request
          </Typography>
          <Typography variant="body2" color={colors.textMuted} sx={{ fontSize: '0.85rem' }}>
            Location: {propertyDetails.location || "Not specified"}
          </Typography>
          <Typography variant="body2" color={colors.textMuted} sx={{ fontSize: '0.85rem' }}>
            Budget: {propertyDetails.min_budget && propertyDetails.max_budget 
              ? `₹${propertyDetails.min_budget.toLocaleString()} - ₹${propertyDetails.max_budget.toLocaleString()}` 
              : "Not specified"}
          </Typography>
        </Box>
      )} */}

      {/* Responses List */}
      <Box sx={{ p: 2, flex: 1, pb: 4 }}>
        {responses.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h6" color={colors.textMuted}>
              No responses found
            </Typography>
            <Button 
              onClick={() => navigate(-1)}
              sx={{ 
                mt: 2, 
                color: colors.secondary,
                textTransform: 'none'
              }}
            >
              Go Back
            </Button>
          </Box>
        ) : (
          <Box>
            {responses.map((response, index) => renderResponseItem(response, index))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AllResponsesPage;